// theme.js
import { createTheme } from '@mui/material/styles';

// Define your custom font weights
const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

// Create the theme
const theme = createTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',

    h1: {
      fontSize: '3rem', // 48px
      fontWeight: fontWeights.bold,
      lineHeight: 1.25,
      margin: 0,
    },
    h2: {
      fontSize: '2.5rem', // 40px
      fontWeight: fontWeights.bold,
      lineHeight: 1.25,
      margin: 0,
    },
    h3: {
      fontSize: '2rem', // 32px
      fontWeight: fontWeights.bold,
      lineHeight: 1.25,
      margin: 0,
    },
    h4: {
      fontSize: '1.5rem', // 24px
      fontWeight: fontWeights.bold,
      lineHeight: 1.25,
      margin: 0,
    },
    h5: {
      fontSize: '1.25rem', // 20px
      fontWeight: fontWeights.bold,
      lineHeight: 1.25,
      margin: 0,
    },
    h6: {
      fontSize: '1rem', // 16px
      fontWeight: fontWeights.bold,
      lineHeight: 1.25,
      margin: 0,
    },
    body1: {
      fontSize: '1rem', // 16px
      fontWeight: fontWeights.regular,
      lineHeight: 1.5,
    },
    button: {
      textTransform: 'none',
      fontWeight: fontWeights.medium,
    },
  },
  palette: {
    primary: {
      main: 'rgb(0, 0, 0)',
      contrastText: '#fff',
    },
    secondary: {
      main: 'rgb(138, 140, 140)',
      contrastText: '#000',
    },
    background: {
      default: '#fff',
      paper: '#f5f5f5',
    },
  },
  customShadows: {
    customLight: '0px 1px 3px #ddd',
  },
  components: {}
});

export default theme;
